import { render } from "./404page.vue?vue&type=template&id=65ff1035"
import script from "./404page.vue?vue&type=script&lang=js"
export * from "./404page.vue?vue&type=script&lang=js"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__